<template lang="pug">
    .error
        .error-box
            .error-box__header
                | {{ $i18n.t('common.common_serverIsOnUpdateInfo') }}
            .error-box__body
                .error-box__text
</template>

<script>
    import api from '../../api/connectionApi.js';
    import CsFooter from '../../oldLayouts/auth/Footer.vue';

    export default {
        mounted() {
            this.intervalId = setInterval(this.tryToConnect, 5000);
        },
        beforeDestroy() {
            clearInterval(this.intervalId);
        },
        data() {
            return {
                intervalId: null,
            };
        },
        methods: {
            tryToConnect() {
                api.tryToConnect()
                    .then(response => {
                        if (response.status === 200 && response.statusText === 'OK') {
                            this.$router.push({ name: 'dashboard' });
                        }
                    })
                    .catch(error => {
                        if (error.status && error.status === 503) {
                            this.$toasted.info(this.$i18n.t('errors.server_is_on_update'));
                        }
                    });
            },
        },
        components: {
            CsFooter,
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/assets/sass/errors/errors.scss';
</style>
